export class TipoSensor {
	_id: string;
	descripcion: string;
	//tipoVariable: string;
	estado: boolean;
	//unidadMedidaDefault: string;
	rangoDesde: Number;
	rangoHasta: Number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoSensor/tipoSensor.ts